<template>
  <RouterLink
    :to="to"
    class="nav-item hover:bg-[#25B0D725] duration-700 hover:scale-110 active:scale-90"
    :class="{ active: isActive }"
    @mouseenter="onMouseEnter"
    @mouseleave="onMouseLeave"
    @click="onClick"
  >
    <div ref="lottieContainer" class="icon-container">
      <div
        ref="lottieElement"
        class="icon"
        :class="{ 'icon-active': isActive, 'icon-inactive': !isActive }"
      />
    </div>
    <span
      class="nav-title"
      :class="{ 'title-active': isActive, 'title-inactive': !isActive }"
    >
      {{ title }}
    </span>
  </RouterLink>
</template>

<script setup>
import { ref, onMounted, onUnmounted, computed } from 'vue'
import { useRoute } from 'vue-router'
import lottie from 'lottie-web'
// import { gsap } from 'gsap'

const props = defineProps({
  to: String,
  iconAnimated: JSON,
  title: String
})

const isHover = ref(false)
const route = useRoute()
const isActive = computed(() => {
  const path = route.path || ''
  // Luz y Gas del cliente son el listado de solicitudes acotado por suministro:
  // se resaltan como parte de Suministros, no de Solicitudes.
  const isSupplySection = path === '/request' && Boolean(route.query?.supply)
  if (path === props.to) return !isSupplySection
  if (props.to === '/supplys' && isSupplySection) return true
  // Special-case: treat `/request-detail-superadmin/:id` as active for `/request`
    if (props.to === '/request' && path.startsWith('/request-detail-superadmin')) return true
    if (props.to === '/user' && (path.startsWith('/user-detail') || path.startsWith('/new-user') || path === '/user-new' )) return true
    if (props.to === '/supplys' && (
      path.startsWith('/Property') ||
      path.startsWith('/Property-detail') ||
      path === '/luz' ||
      path.startsWith('/light-detail') ||
      path.startsWith('/add-light') ||
      path === '/gas' ||
      path.startsWith('/add-gas') ||
      path.startsWith('/gas-detail') ||
      path === '/supply-bill' ||
      path === '/new-bill' ||
      path === '/client-admin' ||
      path.startsWith('/new-admin') ||
      path.startsWith('/admin-detail')
    )) return true
  return false
})
const lottieElement = ref(null)
const lottieContainer = ref(null)
let lottieInstance = null

onMounted(() => {
  if (props.iconAnimated && lottieElement.value) {
    lottieInstance = lottie.loadAnimation({
      container: lottieElement.value,
      renderer: 'svg',
      loop: false,
      autoplay: false,
      animationData: props.iconAnimated
    })
    lottieInstance.goToAndStop(0, true) // Muestra el primer frame (estático)
  }
})

onUnmounted(() => {
  if (lottieInstance) lottieInstance.destroy()
})

function onMouseEnter() {
  isHover.value = true
  if (lottieInstance) lottieInstance.play()
}

function onMouseLeave() {
  isHover.value = false
  if (lottieInstance) lottieInstance.goToAndStop(0, true)
}

function onClick() {
  // noop: don't try to mutate computed `isActive`
}
</script>

<style scoped>
.nav-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 10px;
  width: 100%;
  box-sizing: border-box;
  border-radius: 10px;
  transition: background-color 0.3s ease;
}

.nav-item.active {
  background-color: #59E3FF;
  transition: color 0.6s ease-in-out;
}

/* Icon Styles */
.icon {
  width: 40px;
  height: 35px;
  transition: color 0.3s ease-in-out;
}

.icon-inactive {
  filter: none;
  /* color: #25B0D7; */
}

.icon-active {
  filter: brightness(0) invert(1);
  /* color: #25B0D7; */
}

/* Title styles */
.nav-title {
  margin-top: 5px;
  margin-left: 0;
  white-space: nowrap;
  opacity: 1;
  font-size: var(--readable-label-size);
  font-weight: var(--readable-label-weight);
  text-align: center;
  width: auto;
  transition: color 0.3s ease;
}

.title-inactive {
  color: var(--readable-label-color);
}

.title-active {
  color: white;
}
</style>
